export const SET_SELECTED_TEMPLATE: string = "SET_SELECTED_TEMPLATE";
export const SET_SELECTED_URL: string = "SET_SELECTED_URL";
export const SET_CREATED_URL = "SET_CREATED_URL";


export function updateSelectedTemplate(templateId: string): IActionType {
    return { type: SET_SELECTED_TEMPLATE, payload: templateId };
}

export function updateSelectedUrl(urlId: string): IActionType {
    return { type: SET_SELECTED_URL, payload: urlId };
}

export function updateCreatedUrl(shortUrl: string): IActionType {
    return { type: SET_CREATED_URL, payload: shortUrl };
}

export interface IActionType { type: string, payload: string }

